export default __webpack_public_path__ + "static/media/img-0387-switzerland-premium-face.fea62177.png";